// A timeout that only counts time the tab is visible. Background tabs throttle
// timers and iframes (FramePay's included), so a hidden tab can't be expected to
// finish in time. Becoming visible again restarts the full budget.
export const visibleTimeout = (ms: number, onTimeout: () => void): { arm: () => void; cancel: () => void } => {
  let timer: ReturnType<typeof setTimeout> | null = null
  let cancelled = false

  const arm = () => {
    if (timer) clearTimeout(timer)
    timer = null
    if (cancelled || document.visibilityState === 'hidden') return
    timer = setTimeout(() => {
      cancel()
      onTimeout()
    }, ms)
  }

  const cancel = () => {
    cancelled = true
    if (timer) clearTimeout(timer)
    timer = null
    document.removeEventListener('visibilitychange', arm)
  }

  document.addEventListener('visibilitychange', arm)
  arm()
  return { arm, cancel }
}
